export enum ApiStatus {
    Success = 'success',
    Failed = 'failed',
    Offline = 'offline'
}
